<template>
  <div class="hero-container">
    <!-- ヒーロー動画セクション -->
    <div class="hero-video-section">
      <video
        src="/hero_video.mp4"
        class="hero-video"
        autoplay
        muted
        loop
        playsinline
        disablePictureInPicture
        controlslist="nodownload nofullscreen noremoteplayback"
      ></video>
      
      <!-- テキストオーバーレイ -->
      <div class="hero-text-overlay">
        <h1 class="hero-title js-text">
          <!-- 1行目 -->
          <div class="text-line">
            <span>私</span>
            <span>た</span>
            <span>ち</span>
            <span>の</span>
            <span>会</span>
            <span>社</span>
            <span>は</span>
          </div>
          <!-- 2行目 -->
          <div class="text-line">
            <span class="challenge">挑</span>
            <span class="challenge">戦</span>
            <span>と</span>
            <span class="growth">成</span>
            <span class="growth">長</span>
          </div>
          <!-- 3行目 -->
          <div class="text-line">
            <span>で</span>
            <span>で</span>
            <span>き</span>
            <span>て</span>
            <span>い</span>
            <span>る</span>
          </div>
        </h1>
      </div>
    </div>
    
    <!-- スクロールアロー -->
    <div class="scroll-arrow">
      <img src="../assets/top/scroll_sp.png" alt="scroll down" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Object,
  },
};
</script>

<script setup>
import { onMounted } from 'vue'

onMounted(() => {
  window.gsap.fromTo(
    '.js-text span',
    {
      y: 40,           // 下から登場
      autoAlpha: 0,    // 透明状態から
    },
    {
      y: 0,            // 元の位置に移動
      autoAlpha: 1,    // 表示
      duration: 0.4,   // 速さ
      stagger: 0.05,   // 一文字ずつズレて
      ease: 'power2.out', // なめらかな動き
    }
  )
})
</script>

<style scoped>
.hero-container {
  position: relative;
  width: 100%;
  max-width: 1600px;
  height: 45vh;
  margin: 60px auto;
  overflow: hidden;
  border-radius: 8px;
}

.hero-video-section {
  position: relative;
  width: 100%;
  height: 100%;
}

.hero-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
}

.hero-video::-webkit-media-controls-enclosure {
  display: none !important;
}

.hero-video::-webkit-media-controls {
  display: none !important;
}

.hero-video::-webkit-media-controls-panel {
  display: none !important;
}

.hero-video::-webkit-media-controls-play-button {
  display: none !important;
}

.hero-video::-webkit-media-controls-start-playback-button {
  display: none !important;
}

.hero-text-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  text-align: center;
}

.hero-title {
  color: #fdfdfd;
  text-shadow: 0 0 3px rgba(0, 0, 0, 0.6), 0 0 6px rgba(0, 0, 0, 0.4), 0 0 12px rgba(0, 0, 0, 0.3);
  font-weight: bold;
  margin: 0;
}

.text-line {
  display: flex;
  justify-content: center;
  margin-bottom: 0.2em;
}

.text-line span {
  display: inline-block;
  white-space: pre;
}

.challenge {
  color: #ff4444 !important;
}

.growth {
  color: #ff6b35 !important;
}

.scroll-arrow {
  position: absolute;
  bottom: 15px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  display: none; /* PC版では非表示 */
}

.scroll-arrow img {
  width: 40px;
  height: auto;
  opacity: 0.8;
}

/* レスポンシブ対応 */
@media (max-width: 768px) {
  .hero-title {
    font-size: 6vw;
  }
  
  .hero-container {
    width: 95%;
    margin: 40px auto;
  }
  
  .scroll-arrow {
    display: block; /* モバイル版では表示 */
    bottom: 10px;
  }
  
  .scroll-arrow img {
    width: 30px;
  }
}

@media (min-width: 769px) and (max-width: 1200px) {
  .hero-title {
    font-size: 2.7vw;
  }
}

@media (min-width: 1201px) {
  .hero-title {
    font-size: 1.8vw;
  }
}
</style>
